import React from "react";
import TradeHistorySection from "../sections/TradeHistorySection/Content";
const TradeHistoryPage = () => {
  return <TradeHistorySection />;
};

export default TradeHistoryPage;
